import { useMemo } from 'react';
import debounce from 'lodash/debounce';

export default function useDebounce(func, time = 50, opts = {}, deps = []) {
  // the deps array is legit - no idea how we can statically get this checked though
  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  return useMemo(() => debounce(func, time, opts), deps);
}
